import Header from "../../Components/Header"
import { useEffect, useState } from "react";
import Predict from "../../Components/Predict"
import Howtoplay from "../../Components/Howtoplay"
import { tinyV } from '../../assets'
import fallbackHeroBg from '../../Asserts/images/fallback_hero_bg.png'
import fallbackMobileBg from '../../Asserts/images/fallback_mobile_bg.png'
import Faq from "../../Components/Faq"
import Footer from "../../Components/Footer"
import HowtoplayMob from "../../Components/HowtoplayMob"
import "../../../App.css"
import axios from "axios";
import { useRef } from "react";
import { baseURL } from "../../services/axiosConfig";
import { useLocation, useNavigate } from "react-router-dom";
import useDeviceType from "../../Utiles/FindDevice";
import Player from "@vimeo/player";
import FloatingVideo from "./FloatingVideo";
import barThumbImg from '../../Asserts/images/barThumbImg.svg';

export default function Pnp() {
    const [scrolled, setScrolled] = useState(false);

    const [showFloatingVideo, setShowFloatingVideo] = useState(() => {
        return !sessionStorage.getItem("landingVisited");
    });

    const [isMobile, setIsMobile] = useState(false);
    const [showEntryPrompt, setShowEntryPrompt] = useState(false);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const videoRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();


    const deviceType = useDeviceType();



    // useEffect(() => {
    //     
    //     sessionStorage.setItem("landingVisited", "true");
    // }, [location.pathname]);


    useEffect(() => {
        if (!sessionStorage.getItem("landingVisited")) {
            sessionStorage.setItem("landingVisited", "true");
        }
        // Remove flag on refresh/unload
        const handleUnload = () => {
            sessionStorage.removeItem("landingVisited");
        };
        window.addEventListener("beforeunload", handleUnload);
        return () => {
            window.removeEventListener("beforeunload", handleUnload);
        };
    }, []);

    useEffect(() => {
        if (location.pathname !== "/") {
            setShowFloatingVideo(false);
        }
    }, [location.pathname]);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };


        const handleResize = () => {
            setIsMobile(window.innerWidth < 520);
        };


        handleResize();


        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);


        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        //if (!sessionStorage.getItem("entryPromptSeen")) {
            setShowEntryPrompt(true);
            //sessionStorage.setItem("entryPromptSeen", "true");
        //}
    }, []);

    useEffect(() => {
        if (!showVideoModal) return;

        const iframe = document.getElementById("vimeo-player");
        if (!iframe) return;

        const player = new Player(iframe);

        let milestones = { 20: false, 50: false, 70: false, start: false, complete: false };
        const videoId = "1108567199";
        const videoTitle = "How to Play";
        let videoDuration = 0;
        // Get userId if logged in
        let userId = null;
        try {
            const userInfo = localStorage.getItem("userInfo");
            userId = userInfo ? JSON.parse(userInfo).userId : undefined;
        } catch { userId = undefined; }

        // Get duration once
        player.getDuration().then((duration) => {
            videoDuration = duration;
        });

        // Video start event
        player.on("play", () => {
            if (!milestones.start) {
                window.dataLayer.push({
                    event: "video_start",
                    videoId,
                    videoTitle,
                    videoDuration
                });
                milestones.start = true;
            }
        });

        // Progress events
        const onTimeUpdate = (data) => {
            const percent = (data.seconds / data.duration) * 100;
            if (!milestones[20] && percent >= 20) {
                window.dataLayer.push({
                    event: "video_progress",
                    videoId,
                    progress: "20%"
                });
                milestones[20] = true;
            }
            if (!milestones[50] && percent >= 50) {
                window.dataLayer.push({
                    event: "video_progress",
                    videoId,
                    progress: "50%"
                });
                milestones[50] = true;
            }
            if (!milestones[70] && percent >= 70) {
                window.dataLayer.push({
                    event: "video_progress",
                    videoId,
                    progress: "70%"
                });
                milestones[70] = true;
            }
            // Video complete event (when 98%+ watched)
            if (!milestones.complete && percent >= 98) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "video_complete",
                    videoId
                });
                milestones.complete = true;
            }
        };

        player.on("timeupdate", onTimeUpdate);

        return () => {
            player.off("timeupdate", onTimeUpdate);
            player.unload();
        };
    }, [showVideoModal]);

    useEffect(() => {
        const handleHashScroll = () => {
            if (location.hash === '#howtoplay') {
                const timeoutId = setTimeout(() => {
                    const isMobileView = window.innerWidth < 768;
                    const elementId = isMobileView ? 'howtoplay-mobile' : 'howtoplay-desktop';
                    const element = document.getElementById(elementId);


                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    } else {
                        setTimeout(() => {
                            const retryElement = document.getElementById(elementId);
                            if (retryElement) {
                                retryElement.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }
                        }, 500);
                    }
                }, 300);


                return () => clearTimeout(timeoutId);
            }
        };


        handleHashScroll();


        const handleHashChange = () => {
            handleHashScroll();
        };


        window.addEventListener('hashchange', handleHashChange);


        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [location.hash, location.pathname]);


    const handleVideoClick = () => {
        setShowVideoModal(true);
    };


    const closeVideoModal = () => {
        setShowVideoModal(false);
    };


    const handleModalClick = (e) => {
        if (e.target === e.currentTarget) {
            closeVideoModal();
        }
    };


    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && showVideoModal) {
                closeVideoModal();
            }
        };


        if (showVideoModal) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }


        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [showVideoModal]);


    const [banner, setBanner] = useState({ desktop: null, mobile: null, predict: null });


    useEffect(() => {
        (async () => {
            try {
                const response = await axios.get(
                    `${baseURL}/accounts/adv-banner/list/`
                );


                const desktopBanner = response?.data?.find(
                    (b) => b?.placement === "landing_page" && b?.enabled === true
                );
                const mobileBanner = response?.data?.find(
                    (b) => b?.placement === "landing_page_mobile" && b?.enabled === true
                );
                const predictBanner = response?.data?.find(
                    (b) => b?.placement === "landing_rounds" && b?.enabled === true
                );
                setBanner({
                    desktop: desktopBanner || { image: fallbackHeroBg },
                    mobile: mobileBanner || { image: fallbackMobileBg },
                    predict: predictBanner || null
                });
            } catch (error) {
                // console.error("Error fetching banner data:", error);
            }
        })();
    }, []);


    const getTextAlignmentAndJustify = (enabled, side) => {
        if (!enabled) {
            return {
                text: deviceType === 'mobile' ? 'text-center' : 'text-left',
                justify: deviceType === 'mobile' ? 'justify-center' : 'justify-start',
            };
        }
        switch (side) {
            case 'left':
                return { text: 'text-left', justify: 'justify-start' };
            case 'right':
                return { text: 'text-right', justify: 'justify-end' };
            case 'center':
                return { text: 'text-center', justify: 'justify-center' };
            default:
                return { text: deviceType === 'mobile' ? 'text-center' : 'text-left', justify: deviceType === 'mobile' ? 'justify-center' : 'justify-start' };
        }
    };


    const { text: currentTextAlignment, justify: currentJustify } = deviceType === 'mobile'
        ? getTextAlignmentAndJustify(banner?.mobile?.enabled, banner?.mobile?.text_placement_side)
        : getTextAlignmentAndJustify(banner?.desktop?.enabled, banner?.desktop?.text_placement_side);


    const bgImage =
        deviceType === 'mobile'
            ? banner?.mobile?.image
            : banner?.desktop?.image;


    const getBackgroundSize = () => {
        const width = window.innerWidth;

        if (deviceType === 'mobile') {
            if (width >= 428) {
                return '100% 750px';
            } else if (width >= 390) {
                return '100% 720px';
            } else {
                return '100% 750px';
            }
        }
        if (width >= 1440) {
            return '100% 640px';
        }
        else if (width >= 1024) {
            return '100% 600px';
        }
        else if (width >= 700) {
            return '100% 400px';
        } else if (width >= 600) {
            return '100% 450px';
        }
        else if (width >= 3840) {
            return '100% 800px';
        }


        return '100% 580px';
    };


    const getContainerHeight = () => {
        const width = window.innerWidth;

        if (deviceType === 'mobile') {
            if (width >= 428) {
                return 'h-[750px]';
            } else if (width >= 390) {
                return 'h-[720px]';
            } else {
                return 'h-[750px]';
            }
        }


        if (width >= 1440) {
            return 'h-[640px]';
        } else if (width >= 1024) {
            return 'h-[600px]';
        } else if (width >= 700) {
            return 'h-[400px]';
        }
        else if (width >= 3840) {
            return 'h-[800px]';
        }


        return 'h-[750px] mobile-l:h-[580px] md:h-[400px] lg:h-[600px] xl:h-[640px] 2xl:h-[640px]';
    };


    if (!bgImage) return null;


    return (
        <div className="scroll-smooth">
            <div
                className="sticky top-0 z-[100] w-full transition-all duration-300"
                style={{ backgroundColor: '#002042' }}
            >
                <Header />
            </div>
            <div
                className={`mt-0 ${getContainerHeight()}`}
                style={
                    bgImage
                        ? {
                            backgroundImage: `url('${bgImage}')`,
                            backgroundSize: getBackgroundSize(),
                            backgroundRepeat: 'no-repeat',
                        }
                        : {}
                }
            >
                <div className="laptop-banner:max-w-[1090px] mx-auto laptop-banner:px-0 px-8">
                    {deviceType === 'mobile'
                        ? (banner?.mobile?.enabled
                            ? <h1 className={`pt-12 laptop-banner:text-[48px] md:text-[30px] text-[24px] font-[600] ${currentTextAlignment} -tracking-[.5px] font-archivo`} style={{ color: banner?.mobile?.text_color || '#FFFFFF' }}>
                                {banner?.mobile?.name || ''}
                            </h1>
                            : <h1 className={`pt-12 laptop-banner:text-[48px] md:text-[30px] text-[24px] font-[600] ${currentTextAlignment} -tracking-[.5px] font-archivo`} style={{ color: '#FFFFFF' }}>
                                Welcome to Sportspik
                            </h1>
                        )
                        : (banner?.desktop?.enabled
                            ? <h1 className={`pt-8 laptop-banner:text-[48px] md:text-[34px] text-[22px] font-[600] ${currentTextAlignment} -tracking-[.5px] font-archivo`} style={{ color: banner?.desktop?.text_color || '#FFFFFF' }}>
                                {banner?.desktop?.name || ''}
                            </h1>
                            : <h1 className={`pt-8 laptop-banner:text-[48px] md:text-[34px] text-[22px] font-[600] ${currentTextAlignment} -tracking-[.5px] font-archivo`} style={{ color: '#FFFFFF' }}>
                                Welcome to Sportspik
                            </h1>
                        )
                    }
                    {deviceType === 'mobile'
                        ? ((banner?.mobile?.enabled && bgImage)
                            ? <div className={`flex flex-row ${currentJustify} tracking-[-2px] items-center laptop-banner:text-[60.7px] md:text-[37px] text-[28px] font-[600] leading-[58px] md:leading-[58px] leading-[40px] font-archivo`} style={{ color: banner?.mobile?.text_color || '#FFFFFF' }}>
                                {banner?.mobile?.description || ""}
                            </div>
                            : <div className={`flex flex-row ${currentJustify} tracking-[-2px] items-center laptop-banner:text-[60.7px] md:text-[37px] text-[28px] font-[600] leading-[58px] md:leading-[58px] leading-[40px] font-archivo text-[#00C05B]`}>
                                <div className="flex items-center">
                                    <span>Predict</span>
                                    <svg
                                        className="mx-1 sm:mx-2"
                                        width="20"
                                        height="15"
                                        viewBox="0 0 29 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.33008 8.76699C0.649106 8.76699 0.0970685 9.31903 0.0970684 10C0.0970684 10.681 0.649106 11.233 1.33008 11.233L1.33008 8.76699ZM28.0952 10.8719C28.5767 10.3904 28.5767 9.60965 28.0952 9.12813L20.2483 1.28131C19.7668 0.799786 18.9861 0.799786 18.5046 1.28131C18.0231 1.76283 18.0231 2.54353 18.5046 3.02505L25.4795 10L18.5046 16.975C18.0231 17.4565 18.0231 18.2372 18.5046 18.7187C18.9861 19.2002 19.7668 19.2002 20.2483 18.7187L28.0952 10.8719ZM1.33008 10L1.33008 11.233L27.2233 11.233L27.2233 10L27.2233 8.76699L1.33008 8.76699L1.33008 10Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <div className="flex items-center">
                                    <span>Pick</span>
                                    <svg
                                        className="mx-1 sm:mx-2"
                                        width="20"
                                        height="15"
                                        viewBox="0 0 29 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.33008 8.76699C0.649106 8.76699 0.0970685 9.31903 0.0970684 10C0.0970684 10.681 0.649106 11.233 1.33008 11.233L1.33008 8.76699ZM28.0952 10.8719C28.5767 10.3904 28.5767 9.60965 28.0952 9.12813L20.2483 1.28131C19.7668 0.799786 18.9861 0.799786 18.5046 1.28131C18.0231 1.76283 18.0231 2.54353 18.5046 3.02505L25.4795 10L18.5046 16.975C18.0231 17.4565 18.0231 18.2372 18.5046 18.7187C18.9861 19.2002 19.7668 19.2002 20.2483 18.7187L28.0952 10.8719ZM1.33008 10L1.33008 11.233L27.2233 11.233L27.2233 10L27.2233 8.76699L1.33008 8.76699L1.33008 10Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <span>Win !</span>
                            </div>
                        )
                        : ((banner?.desktop?.enabled && bgImage)
                            ? <div className={`flex flex-row ${currentJustify} tracking-[-2px] items-center laptop-banner:text-[60.7px] md:text-[37px] text-[28px] font-[600] leading-[58px] md:leading-[58px] leading-[40px] font-archivo`} style={{ color: banner?.desktop?.text_color || '#FFFFFF' }}>
                                {banner?.desktop?.description || ""}
                            </div>
                            :
                            <div className={`flex flex-row ${currentJustify} tracking-[-2px] items-center laptop-banner:text-[60.7px] md:text-[37px] text-[28px] font-[600] leading-[58px] md:leading-[58px] leading-[40px] font-archivo text-[#00C05B]`}>
                                <div className="flex items-center">
                                    <span>Predict</span>
                                    <svg
                                        className="mx-1 sm:mx-2"
                                        width="20"
                                        height="15"
                                        viewBox="0 0 29 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.33008 8.76699C0.649106 8.76699 0.0970685 9.31903 0.0970684 10C0.0970684 10.681 0.649106 11.233 1.33008 11.233L1.33008 8.76699ZM28.0952 10.8719C28.5767 10.3904 28.5767 9.60965 28.0952 9.12813L20.2483 1.28131C19.7668 0.799786 18.9861 0.799786 18.5046 1.28131C18.0231 1.76283 18.0231 2.54353 18.5046 3.02505L25.4795 10L18.5046 16.975C18.0231 17.4565 18.0231 18.2372 18.5046 18.7187C18.9861 19.2002 19.7668 19.2002 20.2483 18.7187L28.0952 10.8719ZM1.33008 10L1.33008 11.233L27.2233 11.233L27.2233 10L27.2233 8.76699L1.33008 8.76699L1.33008 10Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <div className="flex items-center">
                                    <span>Pick</span>
                                    <svg
                                        className="mx-1 sm:mx-2"
                                        width="20"
                                        height="15"
                                        viewBox="0 0 29 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.33008 8.76699C0.649106 8.76699 0.0970685 9.31903 0.0970684 10C0.0970684 10.681 0.649106 11.233 1.33008 11.233L1.33008 8.76699ZM28.0952 10.8719C28.5767 10.3904 28.5767 9.60965 28.0952 9.12813L20.2483 1.28131C19.7668 0.799786 18.9861 0.799786 18.5046 1.28131C18.0231 1.76283 18.0231 2.54353 18.5046 3.02505L25.4795 10L18.5046 16.975C18.0231 17.4565 18.0231 18.2372 18.5046 18.7187C18.9861 19.2002 19.7668 19.2002 20.2483 18.7187L28.0952 10.8719ZM1.33008 10L1.33008 11.233L27.2233 11.233L27.2233 10L27.2233 8.76699L1.33008 8.76699L1.33008 10Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <span>Win !</span>
                            </div>
                        )
                    }
                </div>
            </div>
            <main>
                <div>
                    <Predict data={banner.predict} />
                </div>
                <div className="invisible absolute -mt-24" id="howtoplay-desktop"></div>
                <section className="laptop-l-min:py-[6rem] laptop-min:py-[2.5rem] py-[1rem] laptop-min:px-0 px-8 overflow-hidden relative">
                    <div className="laptop-l-min:w-[86%] laptop-min:max-w-[1005px] mx-auto ">
                        <div className="">
                            <h2 className="text-center xl:text-[32px] laptop-l-min:text-[47px] laptop-min:text-[29px] text-[24px] font-[600] text-[#000000] -tracking-[1px] font-archivo">How to play</h2>
                        </div>
                        <div className="laptop-min:block laptop-l-min:block tablet:block hidden">
                            <Howtoplay />
                        </div>
                        <div className="laptop-min:hidden laptop-l-min:hidden tablet:hidden block scroll-target" id="howtoplay-mobile">
                            <HowtoplayMob />
                        </div>
                    </div>
                </section>
                <section className="w-full mt-2 md:mt-0">
                    <div
                        className="flex flex-col lg:flex-row lg:justify-between lg:px-6 lg:items-center rounded-lg sm:flex-col sm:justify-center sm:py-2 sm:px-4 w-[90%] mx-auto px-4 md:px-6 py-3 lg:py-4"
                        style={{ background: 'linear-gradient(90deg, #0B2A47 0%, #1B66AD 100%)' }}
                    >
                        <div className="flex-1 flex flex-col justify-center lg:items-start items-center text-center lg:text-left w-[100%]">
                            <h4 className="laptop-l-min:text-start lg:text-[18px] font-[600] text-[#FAFAFA] -tracking-[.5px] font-archivo w-full lg:text-left text-center">
                                <span className="block sm:inline">Watch & Learn:</span>
                                <span className="block sm:inline sm:ml-1">Full Game Walkthrough  →</span>
                            </h4>
                            {deviceType === "mobile" ? <section><h6 className="laptop-l-min:text-start laptop-min:text-start laptop-l-min:mt-3 laptop-min:mt-2 mt-2 laptop-min:w-[100%] laptop-l-min:text-[22px] laptop-l-min:text-[13px] leading-[20px] font-[400] text-[#FFFFFF99] -tracking-[.5px] font-inter w-full lg:text-left text-center text-[14px]">This video breaks down everything - </h6>
                                <h6 className="laptop-l-min:text-start laptop-min:text-start laptop-l-min:mt-3 laptop-min:mt-2 laptop-min:w-[100%] laptop-l-min:text-[22px] laptop-l-min:text-[13px] leading-[20px] font-[400] text-[#FFFFFF99] -tracking-[.5px] font-inter w-full lg:text-left text-center text-[14px]"> from rules to rewards!</h6></section> : <>
                                <h6 className="laptop-l-min:text-start laptop-min:text-start laptop-l-min:mt-3 laptop-min:mt-2 mt-2 laptop-min:w-[100%] laptop-l-min:text-[22px] laptop-l-min:text-[13px] leading-[20px] font-[400] text-[#FFFFFF99] -tracking-[.5px] font-inter w-full lg:text-left text-center text-[16px]">This video breaks down everything - from rules to rewards!</h6>
                            </>}
                        </div>
                        <div className="w-full flex justify-center items-center lg:w-auto lg:block mt-3 lg:mt-0">
                            <img
                                src={barThumbImg}
                                className="w-full max-w-[280px] px-4 md:px-0 rounded-lg hover:opacity-90 transition-opacity duration-300 cursor-pointer"
                                style={{ objectFit: 'cover' }}
                                alt="Watch & Learn video preview"
                                onClick={handleVideoClick}
                            />
                        </div>
                    </div>
                </section>


                {/* FAQ section */}
                <section className="w-[100%] bg-[#F5F5F5] mt-20">
                    <div className="w-[100%]">
                        <Faq />
                    </div>
                    <div className="w-full flex justify-center py-6">
                        <span
                            onClick={() => navigate('/faqQuestions')}
                            className="text-blue-600 cursor-pointer underline text-sm sm:text-base"
                        >
                            Click for more details
                        </span>
                    </div>
                </section>


                {/* Footer */}
                <Footer />
            </main>
            
{showEntryPrompt && (
  <div
    className="fixed bottom-[20rem] right-4 z-[150] pointer-events-auto"
    style={{ width: "360px" }}
  >
    <div className="bg-[#0B2A47] border border-[#1B66AD] rounded-xl p-5 shadow-xl w-full relative">

      {/* Close Button */}
      <button
        onClick={() => setShowEntryPrompt(false)}
        className="absolute -top-2 -right-2 bg-gray-800 text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-gray-900"
      >
        ✕
      </button>

      <h2 className="text-white text-[18px] font-[600] font-archivo mb-1">
        New to SportsPik?
      </h2>

      <p className="text-[#FFFFFF99] text-[13px] font-inter mb-4">
        Choose how you'd like to continue
      </p>

      <div className="flex flex-col gap-3">
        <button
          onClick={() => {
            setShowEntryPrompt(false);
            navigate("/guest");
          }}
          className="py-2 rounded-lg text-[14px] font-[600] text-white bg-gradient-to-r from-[#00C05B] to-[#1B66AD] hover:opacity-90 transition"
        >
          Yes, I’m New
        </button>

        <button
          onClick={() => {
            setShowEntryPrompt(false);
            navigate("/dashboard");
          }}
          className="py-2 rounded-lg text-[14px] font-[600] text-white border border-[#FFFFFF40] hover:bg-[#1B66AD] transition"
        >
          No, Take Me to Dashboard
        </button>
      </div>

    </div>
  </div>
)}

            {/* Floating Vimeo Video - always bottom right, auto-play */}
            {showFloatingVideo && (
                <FloatingVideo setShowFloatingVideo={setShowFloatingVideo} />
            )}

            {/* Updated Video Modal with dark gray cross icon */}
            {showVideoModal && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[200] p-4 sm:p-6 md:p-8"
                    onClick={handleModalClick}
                >
                    <div className="relative w-full max-w-4xl">
                        {/* Close button with dark gray background and smaller size */}
                        <button
                            className="absolute -top-4 -right-4 text-white hover:text-gray-300 z-10 bg-gray-800 hover:bg-gray-900 rounded-full p-1 transition-all duration-200 shadow-lg"
                            onClick={closeVideoModal}
                            aria-label="Close video"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>


                        {/* Video container */}
                        <div className="bg-black rounded-lg overflow-hidden shadow-2xl">
                            {/* Vimeo embed container */}
                            <div className="relative w-full" style={{ paddingBottom: '56.25%' /* 16:9 aspect ratio */ }}>
                                <iframe
                                    id="vimeo-player"
                                    ref={videoRef}
                                    className="absolute top-0 left-0 w-full h-full"
                                    src="https://player.vimeo.com/video/1129470623"
                                    title="Watch & Learn: Full Game Walkthrough"
                                    frameBorder="0"
                                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <style>
                {`.scroll-target {
                        scroll-margin-top: 1000px;
                }`}
            </style>
        </div>
    )
}
